import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const VIEWPORT_START_OFFSET = 50;

/** Keep `start` in sync with scrollStartAlreadyMet() or visible content can sit between the two thresholds (desktop). */
function scrollTriggerDefaults() {
	return {
		start: `top bottom-=${VIEWPORT_START_OFFSET}px`,
		once: true,
		invalidateOnRefresh: true,
	};
}
const IN_VIEW_LOAD_DELAY = 1.5;

/** True when `el` has already passed the ScrollTrigger start line (would fire immediately on load). */
function scrollStartAlreadyMet(el) {
	const line = window.innerHeight - VIEWPORT_START_OFFSET;
	return el.getBoundingClientRect().top <= line;
}

/** ScrollTrigger ignores `delay` on tweens; use timeline start position instead. */
function entrancePosition(triggerEl) {
	return scrollStartAlreadyMet(triggerEl) ? IN_VIEW_LOAD_DELAY : 0;
}

export default class BlockCommute {
	constructor(block) {
		this.block = block;
		this.title = this.block.querySelector(".block-title");
		this.titleParts = this.title ? Array.from(this.title.children) : [];
		this.titleIcon = this.title ? this.title.querySelector(".block-icon") : null;
		this.titleText = this.title ? this.title.querySelector(".block-title-text") : null;
		this.text = this.block.querySelector(".block-intro-text");
		this.textBlocks = this.text ? Array.from(this.text.children) : [];
		this.linksWrap = this.block.querySelector(".block-links");
		this.links = this.block.querySelectorAll(".block-links .btn");
		this.commuteIntro = this.block.querySelector(".commute-intro");
		this.commuteIntroTitle = this.commuteIntro ? this.commuteIntro.querySelector(".block-subtitle") : null;
		this.commuteIntroText = this.commuteIntro ? this.commuteIntro.querySelector(".block-text") : null;
		this.commuteIntroTextBlocks = this.commuteIntroText ? Array.from(this.commuteIntroText.children) : [];		
		
		this.setStartingPositions();
		this.animateIn();
	}

	setStartingPositions() {
		if (this.titleParts.length) {
			if (this.titleIcon) {
				gsap.set(this.titleIcon, { opacity: 0, x: -64 });
			}
			if (this.titleText) {
				gsap.set(this.titleText, { opacity: 0, x: 64 });
			}
		} else if (this.title) {
			gsap.set(this.title, { opacity: 0, x: -64 });
		}
		if (this.textBlocks.length) {
			gsap.set(this.textBlocks, { opacity: 0, y: 64 });
		}
		if (this.links.length) {
			gsap.set(this.links, { opacity: 0, x: -64 });
		}
		if (this.commuteIntroTitle) {
			gsap.set(this.commuteIntroTitle, { opacity: 0, y: 64 });
		}
		if (this.commuteIntroTextBlocks.length) {
			gsap.set(this.commuteIntroTextBlocks, { opacity: 0, y: 64 });
		}
	}

	animateIn() {
		if (this.title) {
			const pos = entrancePosition(this.title);
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: this.title,
					start: scrollTriggerDefaults().start,
					once: true,
					invalidateOnRefresh: true,
				},
			});
			if (this.titleParts.length) {
				tl.to(
					this.titleParts,
					{
						opacity: 1,
						x: 0,
						duration: 0.5,
						stagger: 0.2,
						ease: "power2.out",
					},
					pos
				);
			} else {
				tl.to(
					this.title,
					{
						opacity: 1,
						x: 0,
						duration: 0.5,
						ease: "power2.out",
					},
					pos
				);
			}
		}

		if (this.text && this.textBlocks.length) {
			const pos = entrancePosition(this.text);
			gsap
				.timeline({
					scrollTrigger: {
						trigger: this.text,
						start: scrollTriggerDefaults().start,
					once: true,
					invalidateOnRefresh: true,
					},
				})
				.to(
					this.textBlocks,
					{
						opacity: 1,
						y: 0,
						duration: 0.75,
						stagger: 0.08,
						ease: "power2.out",
					},
					pos
				);
		}

		if (this.links.length && this.linksWrap) {
			const pos = entrancePosition(this.linksWrap);
			gsap
				.timeline({
					scrollTrigger: {
						trigger: this.linksWrap,
						start: scrollTriggerDefaults().start,
					once: true,
					invalidateOnRefresh: true,
					},
				})
				.to(
					this.links,
					{
						opacity: 1,
						x: 0,
						duration: 0.5,
						stagger: 0.2,
						ease: "power2.out",
					},
					pos
				);
		}

		if (this.commuteIntroTitle) {
			const pos = entrancePosition(this.commuteIntroTitle);
			gsap.timeline({
				scrollTrigger: {
					trigger: this.commuteIntroTitle,
					start: scrollTriggerDefaults().start,
					once: true,
					invalidateOnRefresh: true,
				},
			}).to(this.commuteIntroTitle, {
				opacity: 1,
				y: 0,
				duration: 0.5,
				ease: "power2.out",
			}, pos);
		}

		if (this.commuteIntroText && this.commuteIntroTextBlocks.length) {
			const pos = entrancePosition(this.commuteIntroText);
			gsap.timeline({
				scrollTrigger: {
					trigger: this.commuteIntroText,
					start: scrollTriggerDefaults().start,
					once: true,
					invalidateOnRefresh: true,
				},
			}).to(this.commuteIntroTextBlocks, {
				opacity: 1,
				y: 0,
				duration: 0.5,
				stagger: 0.2,
				ease: "power2.out",
			}, pos);
		}
	}
}
